export enum NoteTypeEnum {
  Information = 0,
  Warning = 1,
  Error = 2,
  Waiting = 3,
}
